export function NewVehicleGroupCtrl ($scope, $uibModalInstance, workshopAPI, messages) {
  
  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };
  
  $scope.save = function (form) {
    workshopAPI.post('/vehicle_body_group_types', $scope.group, 'vehicle_body_group_types')
    .then(function (groups) {
      $uibModalInstance.close({
        groups: groups,
        group: $scope.group
      });
    }, function (err) {
      messages.error(err, form);
    });
  };
  
};
